export default async element => { // '[data-slide-replace]'
	element.addEventListener('click',event => {
		event.preventDefault();
		[...document.querySelectorAll(element.dataset.slideReplace)].forEach(slideDown => {
			slideDown.classList.add('collapsible');
			slideDown.style.display = '';
			setTimeout(()=> slideDown.classList.add('expanded'),80);
		});
		element.classList.add('collapsible');
	});	
};